import React from "react";
import { Routes, Route } from "react-router-dom";

import SellerDashboard from "../pages/seller/SellerDashboard";

const SellerRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<SellerDashboard />} />
    </Routes>
  );
};

export default SellerRoutes;